import { CLOSE_MODAL, OPEN_MODAL, SET_MODAL_MESSAGE } from './constants';

export const closeModal = () => ({
	type: CLOSE_MODAL,
});

export const openModal = () => ({
	type: OPEN_MODAL,
});

export const setModalMessage = message => ({
	type: SET_MODAL_MESSAGE,
	message,
});
